import { render, staticRenderFns } from "./url.vue?vue&type=template&id=33614a9d&scoped=true"
import script from "./url.vue?vue&type=script&lang=js"
export * from "./url.vue?vue&type=script&lang=js"
import style0 from "./url.vue?vue&type=style&index=0&id=33614a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33614a9d",
  null
  
)

export default component.exports